import React from 'react';
import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';

export const OrderDetailPage = lazy(
  () =>
    import('./OrderDetailPage.eager').then(mod => ({
      default: mod.OrderDetailPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
